// extracted by mini-css-extract-plugin
export default {"SkeletonSearchForm":"SkeletonSearchForm_SkeletonSearchForm__v1EsG","skeleton-search-control-item":"SkeletonSearchForm_skeleton-search-control-item__bJFUF"};